/* global kakao */
import { useRef, useEffect } from "react";
import "./Location.scss";
import {
  MdHomeFilled,
  MdKeyboardArrowLeft,
  MdKeyboardArrowRight,
} from "react-icons/md";
import { useState } from "react";
import { FaSearchPlus } from "react-icons/fa";
import { BsDot } from "react-icons/bs";
import { Link } from "react-router-dom";
import axios from "axios";

function Location() {
  useEffect(() => {
    getModalData();
  }, []);
  const [policyData, setPolicyData] = useState(null);
  const [ePolicyData, setEPolicyData] = useState(null);
  const [mapData, setMapData] = useState(null);

  const getModalData = async () => {
    try {
      const response = await axios.get(`/api/contents-type`, {
        params: {
          type: 3,
        },
      });
      setMapData(response.data.contents);
    } catch (error) {
      console.log(error);
    }
  };
  return (
    <>
      <div>
        <div className=" location_wrap">
          <div className="location">
            <Link to="/">
              <MdHomeFilled />
            </Link>
            <MdKeyboardArrowRight />
            <Link to="/location">위치안내</Link>
          </div>
        </div>

        <div className="contain map_wrap">
          <div>
            <div className="my_page map_contain">
              <div
                className="jodit-wysiwyg"
                dangerouslySetInnerHTML={{ __html: mapData }}
              ></div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Location;
